module.exports = __webpack_public_path__ + "fonts/lacuna-italic.2ad1d407.ttf";